!function(window) {
// babel-polyfills
// require("babel-polyfill");


/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */
jQuery.cookie = function (name, value, options) {
	if (typeof value != "undefined") {
		options = options || {};
		if (value === null) {
			value = "";
			options.expires = -1
		}
		var expires = "";
		if (options.expires && (typeof options.expires == "number" || options.expires.toUTCString)) {
			var date;
			if (typeof options.expires == "number") {
				date = new Date();
				date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000))
			} else {
				date = options.expires
			}
			expires = "; expires=" + date.toUTCString()
		}
		var path = options.path ? "; path=" + (options.path) : "";
		var domain = options.domain ? "; domain=" + (options.domain) : "";
		var secure = options.secure ? "; secure" : "";
		document.cookie = [name, "=", encodeURIComponent(value), expires, path, domain, secure].join("")
	} else {
		var cookieValue = null;
		if (document.cookie && document.cookie != "") {
			var cookies = document.cookie.split(";");
			for (var i = 0; i < cookies.length; i++) {
				var cookie = jQuery.trim(cookies[i]);
				if (cookie.substring(0, name.length + 1) == (name + "=")) {
					cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
					break
				}
			}
		}
		return cookieValue
	}
};

require("../jquery-extended-arctur")(jQuery);
require("../form.validators")(jQuery);

// URL plugin

jQuery.url = function () {
	var segments = {};
	var parsed = {};
	var options = {
		url: window.location,
		strictMode: false,
		key: ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "relative", "path", "directory", "file", "query", "anchor"],
		q: {
			name: "queryKey",
			parser: /(?:^|&)([^&=]*)=?([^&]*)/g
		},
		parser: {
			strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*):?([^:@]*))?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
			loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*):?([^:@]*))?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
		}
	};
	var parseUri = function () {
		var str = decodeURI(options.url);
		var m = options.parser[options.strictMode ? "strict" : "loose"].exec(str);
		var uri = {};
		var i = 14;
		while (i--) {
			uri[options.key[i]] = m[i] || ""
		}
		uri[options.q.name] = {};
		uri[options.key[12]].replace(options.q.parser, function ($0, $1, $2) {
			if ($1) {
				uri[options.q.name][$1] = $2
			}
		});
		return uri
	};
	var key = function (key) {
		if (!parsed.length) {
			setUp()
		}
		if (key == "base") {
			if (parsed.port !== null && parsed.port !== "") {
				return parsed.protocol + "://" + parsed.host + ":" + parsed.port + "/"
			} else {
				return parsed.protocol + "://" + parsed.host + "/"
			}
		}
		return (parsed[key] === "") ? null : parsed[key]
	};
	var param = function (item) {
		if (!parsed.length) {
			setUp()
		}
		return (parsed.queryKey[item] === null) ? null : parsed.queryKey[item]
	};
	var setUp = function () {
		parsed = parseUri();
		getSegments()
	};
	var getSegments = function () {
		var p = parsed.path;
		segments = [];
		segments = parsed.path.length == 1 ? {} : (p.charAt(p.length - 1) == "/" ? p.substring(1, p.length - 1) : p.substring(1)).split("/")
	};
	return {
		setMode: function (mode) {
			strictMode = mode == "strict" ? true : false;
			return this
		},
		setUrl: function (newUri) {
			options.url = newUri === undefined ? window.location : newUri;
			setUp();
			return this
		},
		segment: function (pos) {
			if (!parsed.length) {
				setUp()
			}
			if (pos === undefined) {
				return segments.length
			}
			return (segments[pos] === "" || segments[pos] === undefined) ? null : segments[pos]
		},
		attr: key,
		param: param
	}
}();


// nastavi invisible recaptcho za vse forme in jo pokliče na submit forme

var captchaCallback = function(){
	var widgetAttr = 'data-widgetid';
	var recaptchaClass = '.g-recaptcha';
	var recaptchaRespons = '.g-recaptcha-response';
	$(recaptchaClass).each(function(index, el) {
		var form = $(el).closest("form");
		var widgetId = grecaptcha.render(el, {
			'sitekey' : jQuery(el).attr('data-sitekey'), 
			'callback' : token => {
				form.find(recaptchaRespons).val(token);
				form.submit();
			}
		});
		$(el).attr(widgetAttr, widgetId);
	});

	$('.arctur-form [type=submit]').on('click', function(ev) {
		ev.preventDefault();
		var widgetId = $(this).closest('form').find(recaptchaClass).attr(widgetAttr);
		grecaptcha.execute(widgetId);	
	});
}


//global variables for responsivness

var urlDirFull = jQuery.url.attr("directory");
var pageLng = null;


function initilizeLanguageSettings() {
	/* --- language settings --- */

	var htmlLang = $('html').attr('lang');
	if (htmlLang == 'sl') {
		pageLng = 'slo';
	} else if (htmlLang == 'it') {
		pageLng = 'ita';
	} else if (htmlLang == 'de') {
		pageLng = 'deu';
	} else if (htmlLang == 'hr') {
		pageLng = 'hrv';
	} else {
		pageLng = 'eng';
	}

	if (pageLng == 'slo' || pageLng == 'hrv') {
		Date.format = 'dd.mm.yyyy';
		Date.firstDayOfWeek = 1;
		Date.dayNames = ['Nedelja', 'Ponedeljek', 'Torek', 'Sreda', 'Četrtek', 'Petek', 'Sobota'];
		Date.abbrDayNames = ['Ned', 'Pon', 'Tor', 'Sre', 'Čet', 'Pet', 'Sob'];
		Date.monthNames = ['januar', 'februar', 'marec', 'april', 'maj', 'junij', 'julij', 'avgust', 'september', 'oktober', 'november', 'december'];
		Date.abbrMonthNames = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'avg', 'sep', 'okt', 'nov', 'dec'];

		$.dpText = {
			TEXT_PREV_YEAR: 'Prejšnje leto',
			TEXT_PREV_MONTH: 'Prejšnji mesec',
			TEXT_NEXT_YEAR: 'Naslednje leto',
			TEXT_NEXT_MONTH: 'Naslednji mesec',
			TEXT_CLOSE: 'Zapri',
			TEXT_CHOOSE_DATE: 'Izberi datum'
		}
	} else {
		Date.format = 'dd.mm.yyyy';
		Date.firstDayOfWeek = 1;
		Date.dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
		Date.abbrDayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
		Date.monthNames = ['January', 'February', 'March', 'April', 'May', 'Jun', 'Julay', 'August', 'September', 'October', 'November', 'December'];
		Date.abbrMonthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

		$.dpText = {
			TEXT_PREV_YEAR: 'Previews year',
			TEXT_PREV_MONTH: 'Previews month',
			TEXT_NEXT_YEAR: 'Next year',
			TEXT_NEXT_MONTH: 'Next month',
			TEXT_CLOSE: 'Close',
			TEXT_CHOOSE_DATE: 'Select date'
		}
	}
}

//initialize autocomplete - needed for responsivness so its called again on window resize
function initializeAutoComplete() {
	$("#input-search-mini, #input-search-main").autocomplete("/util/string_search.php?lng=" + pageLng, {
		appendTo: '#search-mini-form',
		matchContains: true,
		//mustMatch: true,
		//minChars: 0,
		//multiple: true,
		//highlight: false,
		//multipleSeparator: ",",
		selectFirst: false
	});

}

// set eq height on columns with provided attr
function setEqHeight() {
	removeEqHeight();

	$("[data-eq-columns]").each(function (i, container) {
		var viewPort = $(container).attr('data-eq-columns');
		if ((viewPort && viewport().width > viewPort) || !viewPort) {
			setInternalMultiRowHeight(container);
		}

	});

	function setInternalMultiRowHeight(container) {
	
		var $children = $(container).find(">*:not([item-eq-height-set])");

		if ($children.length) {
			var parentWidth = container.getBoundingClientRect().width;
	
			// $set = 1;
	
			var $items = $(container).find(">*:not([item-eq-height-set])");
			var initialHeight = null;

			// do loop while sum of children width is smaller than container width
			var width = 0;
			var i = 0;
			var affected = [];
			while (width < parentWidth) {
				var child = $items[i];
				var $child = $(child);
				affected.push($child);
				if ($child.height() > initialHeight) {
					initialHeight = $child.height();
				}

				width += $items[i].getBoundingClientRect().width;
				i++;
			}
	
			if (initialHeight) {
				affected.forEach(function(item, index) {
					item.height(initialHeight);
					item.attr('item-eq-height-set', true);
				});
			}
	
			var items = $(container).find(">*:not([item-eq-height-set])");
			if (items.length != 0) {
				setInternalMultiRowHeight(container);
			} else {
				$(container).attr('data-eq-columns-set', '');
			}
		}
	}

	function removeEqHeight() {
		$("[data-eq-columns][data-eq-columns-set]").each(function (i, container) {
			$(container).find(">*").css("height", "auto").removeAttr('item-eq-height-set');
			$(container).removeAttr('data-eq-columns-set');
		});
	}

}

function viewport() {
	var e = window,
		a = 'inner';
	if (!('innerWidth' in window)) {
		a = 'client';
		e = document.documentElement || document.body;
	}
	return {
		width: e[a + 'Width'],
		height: e[a + 'Height']
	};
}

/**
 * Avtomatsko prikaže elemente s [data-slide-container] z izbrane smeri z izbrano hitrostjo
 * možnosti za direction: 'up','down', 'left', 'right'
 * speed je v ms
 */
function openSlideContainers() {
	var $slideContainers = $("[data-slide-container]");
	$slideContainers.hide().addClass('shown');
	$slideContainers.each(function (index, item) {
		var $direction = $(item).attr("data-slide-container");
		var $speed = $(item).attr("data-slide-speed");
		if (!$speed) {
			$speed = 1000;
		}
		if (!isNaN($speed)) {
			$speed = parseInt($speed);
		}
		$(item).show("slide", {
			direction: $direction
		}, $speed);
	});
}


/**
 * Binda element kot triger za prikazovanje druegaga elementa s pomočjo slidanja (jquery ui)
 * možnosti za direction: 'up','down', 'left', 'right'
 * speed je v ms
 */
function bindSlideAnchor() {
	$("[data-slide-anchor]").click('click', function () {
		const $container = $($(this).attr('data-slide-anchor'));
		const $anchor = $(this);

		// show container
		let $speed = $container.attr('data-slide-speed');
		if (!$speed) {
			$speed = 1000;
		}
		$speed = parseInt($speed);
		let $direction = $container.attr('data-slide-start-direction');
		if (!$direction) {
			$direction = 'up';
		}

		// hide container if already shown
		if ($container.attr('data-slide-target') !== null) {
			if ($container.hasClass('shown')) {
				$container.hide("slide", {
					direction: $direction
				}, $speed, function () {
					$container.removeClass('shown');
					$anchor.removeClass('slide-toggle-on');
				});
			} else {
				$container.show("slide", {
					direction: $direction
				}, $speed, function () {
					$container.addClass('shown');
					$anchor.addClass('slide-toggle-on');
				});
			}
		}
	});
}

// autoscrolls to element with [data-scroll-to-on-ready] attribute on window load -> 
// if you add directive [data-scroll-to-include-height] to other elements it includes its height
// to move the scroll for its height lower
function scrollToOnLoadDirective() {

	var $scrollTo = $("[data-scroll-to-on-ready]");
	if ($scrollTo.length != 0) {
		//first found
		var $item = $scrollTo[0];
		//get any items height to be added to
		var includeOtherHeight = 0;
		$("[data-scroll-to-include-height]").each(function (index, item) {
			includeOtherHeight += $(item).height();
		});
		var scrollTop = $($item).offset().top;


		$("html, body").animate({
			scrollTop: scrollTop - includeOtherHeight
		}, 600);

	}
}

/**Functions that dont require document to be ready */
initilizeLanguageSettings();


jQuery(document).ready(function () {

	var options = {
		viewport: {
			size: viewport,
			definition: {
				xs: 480,
				sm: 768,
				md: 992,
				lg: 1230
			}
		}
	}

	require('./lib/vertical-align/vertical-align');

	require("./various-utils")(jQuery);
	
	// main menu bootstrap
	require("./main-menu-bootstrap")(options);

	// main menu legacy - uncomment if needed
	//require("./main-menu-legacy");

	/* --- Search form autocomplete --- */
	initializeAutoComplete();

	$('.input-datepicker').datePicker({
		startDate: '01.01.1900'
	});

	$(document).on('click', '.custom-toggler', function(e){
		e.stopPropagation();
		e.preventDefault();
		$('.mobile-menu').slideToggle();
		$('.hbar').toggleClass('opened');
	});


	/*--- poll ---*/
	jQuery("form#poll-form").submit(function () {
		var responseData = '';
		var lng = jQuery('#pollLng').val();
		if (jQuery('#multi-answers').val() != '1')
			// one answer
			responseData = jQuery("form#poll-form input:checked").val();
		else {
			// multiple answers
			jQuery("form#poll-form input:checked").each(function () {
				responseData += this.value + ' ';
			});
		}
		jQuery.post("/util/ajaxresponse.php?lng=" + lng, {
			func: "poll",
			response: responseData
		}, function (html) {
			showPoll(html);
		});
		return false;
	});

	function showPoll(htmlResponse) {
		jQuery("#poll-container").html(htmlResponse);
		jQuery("#poll-container img").each(function () {
			var tmp = jQuery(this).attr("class");
			var aVals = tmp.match(/[0-9]+$/); // get number at the end of the string
			var val = aVals[0];
			jQuery(this).animate({
				width: val + "px"
			}, 1000);
		});
	}


	/*--- FAQ ---*/
	if ($("div#faq-form-section").length) {
		$("p#faq-form-toggle").slideDown();
		$("p#faq-form-toggle").click(function () {
			$("p#faq-form-toggle").slideUp(500);
			$("div#faq-form-section").slideToggle(500);
		});
	}

	if ($("div#faq-list").length) {
		$("div#faq-list h2").click(function () {
			$(this).next("dl.faq-list").slideToggle(500);
			$(this).next("dl.faq-list").toggleClass('open');
			$(this).toggleClass('open');
		});
	}

	/* --- anchor click scrolling --- */
	$('a[href^="#"]').click(function (e) {
		// scroll to anchor if there is actually more after the # sign in the link
		if ($(this).attr('href').length > 1) {
			var scrollToElementName = $(this).attr('href').substr($(this).attr('href').indexOf("#") + 1);
			scrollTo = $("a[name=" + scrollToElementName + "]").offset().top;
			$('html, body').animate({
				scrollTop: scrollTo
			}, 500);
			e.preventDefault();
		}
	});


	/* --- Calendar --- */
	function initCalendar() {
		// advance a month
		var strId = $('#calendar-response').attr('class');

		if (strId) {
			// Get language
			var aLng = strId.split('_');
			var lng = aLng[1];

			// Load next month
			$("#cal-next-month").click(function (e) {
				var cName = $("#cal-next-month").attr("class");
				var y = cName.substr(6, 4);
				var m = cName.substr(10, 2);
				$("#calendar-response").load("/util/ajaxresponse.php?lng=" + lng, {
					'func': 'outputCalendar',
					'y': y,
					'm': m,
					'eventsStrId': strId
				}, function () {
					initCalendar();
				});
				e.preventDefault();
			});

			// backtrack a month
			$("#cal-prev-month").click(function (e) {
				var cName = $("#cal-prev-month").attr("class");
				var y = cName.substr(6, 4);
				var m = cName.substr(10, 2);
				$("#calendar-response").load("/util/ajaxresponse.php?lng=" + lng, {
					'func': 'outputCalendar',
					'y': y,
					'm': m,
					'eventsStrId': strId
				}, function () {
					initCalendar();
				});
				e.preventDefault();
			});
		}
	}


	/* --- Photogallery --- */
	function initPhotogallery() {
		// Apply orientation classes to the gallery list images
		if ($("#photo-gallery-list").length) {
			$("#photo-gallery-list .photo-gallery-item:not(.server-size)").each(function () {
				var image = $(this).find("img.photo-gallery");

				if (image.height() > image.width()) {
					// portrait
					$(this).addClass("portrait");
				} else {
					// lanscape
					$(this).addClass("landscape");
				}
			});
		}

		// Apply orientation classes to the gallery images
		if ($("#photo-gallery-container").length) {
			$("#photo-gallery-container .photo-gallery-item:not(.server-size)").each(function () {
				var image = $(this).find("img.photo-gallery");

				if (image.height() > image.width()) {
					// portrait
					$(this).addClass("portrait");
				} else {
					// lanscape
					$(this).addClass("landscape");
				}
			});
		}
	}

	initPhotogallery(); // initialize the photogallery

	/* --- Photolist --- */
	// resize the photolist widths for non-standard width photos
	function resizePhotolist() {
		if (jQuery("dl.photo-list").length) {
			var imgWidth = jQuery("dl.photo-list img:first").width();
			var dlWidth = jQuery("dl.photo-list").width();

			jQuery("dl.photo-list dt, dl.photo-list dd.summary").width(dlWidth - imgWidth - 10 + "px");
		}
	}

	/* --- cart ajax --- */
	function addCart() {
		jQuery(".btnCart").click(function (e) {
			var idValue = $(this).attr("id");
			var aId = idValue.split('-');

			var id = aId[1];
			var quantity = $(this).prevAll('p').find("input[name=quantity]").val();
			var price = $(this).prevAll("input[name=price]").val();
			var lng = $(this).prevAll("input[name=lng]").val();
			jQuery($("#cart-wrapper")).load("/util/ajaxresponse.php", {
				'act': 'addCart',
				'lng': lng,
				'quantity': quantity,
				'price': price,
				'articleId': id
			}, function () {
				removeCart();
			});
			e.preventDefault();
		});
	}

	function removeCart() {
		jQuery(".imgCartEdit").click(function (e) {
			var idValue = $(this).attr("id");
			var id = idValue.substring(8);
			var lng = idValue.substr(4, 3);
			jQuery($("#cart-wrapper")).load("/util/ajaxresponse.php", {
				'act': 'removeCart',
				'lng': lng,
				'articleId': id
			}, function () {
				removeCart();
			});
			jQuery($("#editCart")).load("/util/ajaxresponse.php", {
				'act': 'updateShopCart',
				'lng': lng,
				'articleId': id
			}, function () {
				removeCart();
				updateCart();
			});
			e.preventDefault();
		});
	}

	function updateCart() {
		jQuery(".quantity-num").keypress(function (e) {
			if (e.which == 13) {
				var idValue = $(this).attr("id");
				var id = idValue.substring(8);
				var lng = idValue.substr(4, 3);
				var quantity = $(this).val();
				jQuery($("#cart-wrapper")).load("/util/ajaxresponse.php", {
					'act': 'updateCart',
					'lng': lng,
					'articleId': id,
					'quantity': quantity
				}, function () {
					removeCart();
				});
				jQuery($("#editCart")).load("/util/ajaxresponse.php", {
					'act': 'updateCartFrom',
					'lng': lng,
					'articleId': id,
					'quantity': quantity
				}, function () {
					updateCart();
					removeCart();
				});

			}
		});
	}

	function fixMobileTables() {
		// Wrap the tables, which are too wide with an overflow div
		$("article table").each(function () {
			var tWidth = $(this).width();
			var aWidth = $(this).parents('article').eq(0).width();
			if (tWidth > aWidth) {
				if ($(this).parent().hasClass("table-wrapper") == false) {
					$(this).wrap('<div class="table-wrapper"></div>').parent().css({
						'width': aWidth,
						'overflow': 'hidden',
						'overflow-x': 'scroll'
					});
				} else {
					$(this).parent(".table-wrapper").css({
						'width': aWidth
					});
				}
			} else {
				$(this).parent(".table-wrapper").css({
					'width': 'auto',
					'overflow': 'visible'
				});
			}
		});
	}
	fixMobileTables();
	
	var pageSelected = 1;
	// nova funkcija za paging
	function initNewNewsPaging() {
		//$('#pagination').twbsPagination('destroy');
		
		var strId = $("#pagination").attr('data-url');
		
		const urlParams = new URLSearchParams(window.location.search);
		var pageUrl = urlParams.get('page');
		if(pageUrl != null){
			pageSelected = parseInt(pageUrl);
		}
		
		var idRubricUrl = urlParams.get('idRubric');
		if(!idRubricUrl){
			idRubricUrl = '';
		}
		
		var dateFromUrl = urlParams.get('dateFrom');
		if(!dateFromUrl){
			dateFromUrl = '';
		}
		var dateToUrl = urlParams.get('dateTo');
		if(!dateToUrl){
			dateToUrl = '';
		}
		
		window.pagObj = $('#pagination').twbsPagination({
			totalPages: $("#pagination").attr('data-total-pages'),
			visiblePages: 9,
			startPage: pageSelected,
			initiateStartPageClick: false,
			
			onPageClick: function (event, page) {
				var ajaxFunction = "pagedNewsArchive";
				var wrapper = "#"+ajaxFunction;
				
				if(strId == '17_slo'){
					ajaxFunction = "pagedEventsArchive";
					wrapper = "#"+ajaxFunction;
				}
				
				$('#'+idRubricUrl).addClass('selected');
				
				$(wrapper).load("/util/ajaxresponse.php?lng=" + pageLng, {
					'func': ajaxFunction,
					'page': page-1,
					'strId': strId,
					'idRubric': idRubricUrl,
					'dateFrom': dateFromUrl,
					'dateTo': dateToUrl
				}, function() {
					let urlParams = "?page="+page;
					if(idRubricUrl){
						urlParams = urlParams+"&idRubric="+idRubricUrl;
					}
					if(dateFromUrl){
						urlParams = urlParams+"&dateFrom="+dateFromUrl
					}
					if(dateToUrl){
						urlParams = urlParams+"&dateTo="+dateToUrl;
					}
					window.history.pushState(null, null, urlParams);
				});
			}
		});
	}
	initNewNewsPaging();

	function paggingInt() {
		jQuery('.select-page').click(function (e) {
			e.preventDefault();
			var aPage = jQuery(this).attr('id').split('-');
			var strId = jQuery('#pagging-content-wraper').attr('class');

			$("#pagging-content-wraper").load("/util/ajaxresponse.php?lng=" + lng, {
				'func': 'questionsPagging',
				'page': aPage[1],
				'strId': strId
			}, function () {
				paggingInt();
			});

		})

	}
	paggingInt();

	$( "#searchButton" ).click(function(ev) {
		ev.preventDefault();
		$("#navSearchWrapper").toggle();
	});
	
	$("#input-search-mini").on('keypress',function(ev) {
		//ev.preventDefault();
		ev.stopPropagation();
		if(ev.which == 13) {
			//alert('You pressed enter!');
			console.log($(this).closest('form'));
			$(this).closest('form').submit();
			
		}
	});
	
	/*
	function submitHelper() {
		$('.submit-helper').on('click', function(ev) {
			ev.preventDefault();
			ev.stopPropagation();

			$(this).closest('form').submit();
		});
	}
	submitHelper();
	*/

	$(window).scroll(function() {
		if($(window).scrollTop() == $(document).height() - $(window).height()){
			$('#cookie-button').show();
		}else{
			$('#cookie-button').hide();
		}
	});


	/* --- "on load" --- */
	/** SHOPPING CART ADDED */
	function initCart() {
		$.post(
			'/util/ajaxresponse.php',
			{
				act:'initCart',
			},
			function(data){
				$('.numArts').html(data);
				if(data != 0){
					if($(document).width() < 400){
						$('.emptyCart').show();
					}
				} else {
					$('.emptyCart').hide();
				}
			}
		)
	}
	function showCartData(){
		if($('.cartData').length>0){
			$.post(
				'/util/ajaxresponse.php',
				{
					act:'showCart',
					onlyArts: true
				},
				function(data){
					$('.cartData').html(data);
				}
			)
		}
	}
	
	var basketVisible = false;
	var mouseOverCart = false;
	var timerCloseCart = null;
	$(document).on('mouseover', '.shopOver', function(e){
		e.preventDefault();
		if(!basketVisible){
			$.post(
				'/util/ajaxresponse.php',
				{
					act:'showCart',
					onlyArts: false
				},
				function(data){
					$('.basketArticles').html(data);
					$('.basketArticles').slideDown();
				}
			);
			basketVisible = true;
			mouseOverCart = true;
		}
	});
	$(document).on('mouseout', '.basketArticles', function(e){
		e.preventDefault();
		mouseOverCart = false;
		closeCart();
	});
	$(document).on('mouseover', '.basketArticles', function(e){
		e.preventDefault();
		mouseOverCart = true;
		clearInterval(timerCloseCart);
	});
	
	function closeCart(){
		if(!mouseOverCart){
			timerCloseCart = setTimeout(() => {
				console.log("Delayed for 1 second.");
				$('.basketArticles').slideUp();
				basketVisible = false;
			}, 2000)
		}
	}
	
	$(document).on('click', '*', function(e){
		if(basketVisible){
			$('.basketArticles').slideUp();
			basketVisible = false;
		}
	});
	$(document).on('click', '.minus, .plus', function(e){
		e.preventDefault();
		var art = $(this).data('id');
		if(e.target.className == 'plus'){
			$('input[data-id='+art+']').val(parseInt($('input[data-id='+art+']').val())+1);
		} else {
			$('input[data-id='+art+']').val(parseInt($('input[data-id='+art+']').val())-1);
		}
		var quant = $('input[data-id='+art+']').val();
		$.post(
			'/util/ajaxresponse.php',
			{
				articleId:art,
				act:'addToCartFrom',
				quantity:quant
			},
			function(data){
				$('.basketArticles').html(data);
				showCartData();
				initCart();
			}
		)
	});
	$(document).on('click', '.add-to-basket', function(e){
		e.preventDefault();
		var quant = $('input[name="quantity"]').val();
		var art = $(this).attr('id').replace('btn-','');
		$.post(
			'/util/ajaxresponse.php',
			{
				articleId:art,
				act:'addToCart',
				quantity:quant
			},
			function(data){
				$("html, body").animate({ scrollTop: 0 }, "fast");
				$('.numArts').stop();
				$('.numArts').html(data);
				$('.numArts').fadeOut().fadeIn();
				initCart();
			}
		)
	});

	$(document).on('click', '.delete', function(e){
		e.preventDefault();
		var art = $(this).data('id');
		$.post(
			'/util/ajaxresponse.php',
			{
				articleId:art,
				act:'removeFromCart'
			},
			function(data){
				$('.numArts').html(data);
				showCartData();
				initCart();
			}
		)
	});

	$(document).on('click', '.saveOrder', function(e){
		e.preventDefault;
		var formData = $('.orderForm').serialize();
		$.post('/util/ajaxresponse.php', {'act':'saveOrder', 'data':formData}, function(data){
			$('.orderForm').html(data);
		});
		
	});
	if($('.splide-logos').length){
		var splidelogos = new Splide('.splide-logos', {
			perPage: 5,
			type: 'loop',
			autoplay: 'play',
			interval: 2000,
			pauseOnHover: true,
			pauseOnFocus: true,
			pagination: false,
			arrows: false,
			gap: 0,
			breakpoints: {
				'1370': {
					perPage: 5,
					autoplay: 'play',
				},
				'992': {
					perPage: 4,
					autoplay: 'play',
				},
				'768': {
					perPage: 3,
					autoplay: 'play',
				},
				'576': {
					perPage: 2,
					autoplay: 'play',
				},
				'380': {
					perPage: 1,
					autoplay: 'play',
				}
			}
		}).mount();
		/*
		splidelogos.on( 'resize', function () {
			var Autoplay = splidelogos.Components.Autoplay;
			if(window.innerWidth < 1370){
				Autoplay.play();
			}else{
				Autoplay.pause();
			}
		});
		*/
	}
	$('input:text').textBoxHint(); // titles to input text
	$("article a, ul.grouped-link-list a").markExternalLinks(); // adds class to external links
	initCalendar(); // initialize the calendar
	
	
	function setSlick() {
		$('.exposed-news__content').slick({	
			lazyLoad: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			speed: 500,
			cssEase: 'linear',
			asNavFor: '.slider-nav',
			dots: true,
		});
		$('.slider-nav').slick({
			slidesToShow: 1,
			autoplay: true,
			prevArrow: false,
			nextArrow: false,
			autoplaySpeed: 5500,
			slidesToScroll: 1,
			asNavFor: '.exposed-news__content',
			dots: false,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			focusOnSelect: true
		});
	}
	setSlick();
	
	// mobile menu fix
	$(".nav-item.bs-level1.dropdown .nav-link.bs-level1").attr("href", "javascript:void(0)")
	
	function formatDateToISOString(date){
		if(date != undefined){
			const offset = date.getTimezoneOffset()
			date = new Date(date.getTime() - (offset*60*1000))
			return date.toISOString().split('T')[0];
		}
		return '';
		
	}
	function formatDateToString(date){
		return formatDateToISOString(date).split('-').reverse().join('-');
	}
	
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	
	if($('#datepicker').length > 0 ){
		let allDates = $('#eventDates').data("all-dates");
		let allDatesTime = [];
		
		for (const position in allDates) {
			allDates[position] = new Date(allDates[position].replace(/-/g, "/"));
			allDates[position].setHours(0);
			allDatesTime[position] = allDates[position].getTime();
		}
		
		let mindate = new Date(Math.min(...allDates));
		let maxdate = new Date(Math.max(...allDates));
		
		mindate.setDate(mindate.getDate() - 1);
		maxdate.setDate(maxdate.getDate() + 1);
		
		if(mindate == 'Invalid Date') {
			mindate = new Date();
		}
		if(maxdate == 'Invalid Date') {
			maxdate = new Date();
		}
		
		// initialize datepicker (entry page)
		var datepickerEntry = $('#datepicker').datepicker({
			inline: true,
			minDate: mindate,
			maxDate: maxdate,
			prevHtml:'<span class="fa fa-chevron-left" title="Prejšnji mesec"></span>',
			nextHtml:'<span class="fa fa-chevron-right" title="Naslednji mesec"></span>',
			onRenderCell: function (date, cellType) {
				if (cellType == 'day') {
					var isDisabled = !($.inArray(date.getTime(), allDatesTime) != -1);
					return { disabled: isDisabled }
				}
			},
			onSelect: function onSelect(fd, date) {
				$('#selectedDate').val(date);
				var dateString = formatDateToISOString(date);
				
				$(".eventsList").load("/util/ajaxresponse.php?lng=" + lng, {
					'func': 'getEventsByDate',
					'dateString': dateString
				}, function (result) {
					$(".eventsList").html(result);
				});
			}
		});
		
		// clear selected date
		//$('.datepickerWrapper').on('click', function(e){ datepickerEntry.data('datepicker').clear() });
		
	}
	
	if( $('#datepicker-range').length > 0 ){
		
		var datepickerRange = $('#datepicker-range').datepicker({
			//minDate: mindate,
			//maxDate: maxdate,
			prevHtml:'<span class="fa fa-chevron-left" title="Prejšnji mesec"></span>',
			nextHtml:'<span class="fa fa-chevron-right" title="Naslednji mesec"></span>',
			onHide: function(dp, animationCompleted){
				confirmDates(dp);
			}
		});
		
		function confirmDates(dp){
			const urlParams = new URLSearchParams(window.location.search);
			urlParams.set('dateFrom', formatDateToString(dp.selectedDates[0]));
			urlParams.set('dateTo',   formatDateToString(dp.selectedDates[1]));
			urlParams.set('page',1);
			window.location.search = urlParams;
		}
		
		var dateArray = [];
		var dateFromMoment, dateToMoment;
		const dateFrom = urlParams.get('dateFrom');
		if(dateFrom){
			let objDateFrom = new Date(dateFrom.split('-').reverse().join('-'));
			dateArray[0] = objDateFrom;
		}
		const dateTo = urlParams.get('dateTo');
		if(dateTo){
			let objDateTo = new Date(dateTo.split('-').reverse().join('-'));
			dateArray[1] = objDateTo;
		}
		datepickerRange.data('datepicker').selectDate(dateArray);
		
		$('.dateRange .input-group-addon').on('click', function(e){
			datepickerRange.data('datepicker').show();
		});
		$('.datepicker--confirm').on('click', function(e){
			confirmDates(datepickerRange.data('datepicker'));
		});
	}
	
	$(document).on('click', '.filterButton.rubricFilter', function(e){
		e.stopPropagation();
		e.preventDefault();
		
		const urlParams = new URLSearchParams(queryString);
		var link = this.getAttribute("href");
		var dateFrom = '';
		var dateTo = '';
		
		if(urlParams.get('dateFrom') != null){
			dateFrom = '&dateFrom='+urlParams.get('dateFrom');
		}
		if(urlParams.get('dateTo') != null){
			dateTo = '&dateTo='+urlParams.get('dateTo');
		}
		
		if($(this).hasClass('selected')){
			$(".rubricFilter").removeClass('selected');
			window.location.href = '?' + dateFrom + dateTo;
		}else{
			window.location.href = link + dateFrom + dateTo;
		}
	});
	
	
	$("a[rel^='magnific']").magnificPopup({
		type: 'image',
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			tCounter: '%curr%\/%total%'
		},
		closeBtnInside: false,
		closeOnBgClick: true
	});

	/* --- shopping cart --- */
	addCart();
	removeCart();
	updateCart();
	initCart();
	showCartData();
	/* Wait for the whole page to load, including images. */
	$(window).load(function () {
		initPhotogallery(); // initialize the photogallery
		
		$(".owl-carousel").owlCarousel({
			items: 1,
			autoplay: true,
			nav: false,
			dots: true,
			loop: true
		});
		
		setEqHeight();
		openSlideContainers();
		scrollToOnLoadDirective();
	});

	/* --- window resizing --- */

	$(window).resize(function () {
		// resize and/or reposition elements here
		fixMobileTables();
		setEqHeight();
	});

	// initialize leafletmap
	initMapLeaflet();
	
	var map;
	var layerGroup;
	function initMapLeaflet() {
		if ($("#mapLocations").length) {
			map = new L.map('mapLocations',{ scrollWheelZoom: false, zoomControl: false  }).setView([45.961268, 13.648149], 13);
			//map.zoomControl.setPosition('bottomright');
			
			L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}', {
				attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ',
				minZoom: 11,
				maxZoom: 16
			}).addTo(map);

			//add zoom control with your options
			L.control.zoom({position:'topleft'}).addTo(map);

			layerGroup = L.layerGroup().addTo(map); //layer group for markers on map
			getLocationsLeaflet(); // init all markers
		}
	}
	
	var iconMarker = L.icon({
		iconUrl: '/images/icon_marker.svg',
		//shadowUrl: '/lib/leaflet/images/marker-shadow.png',
		iconSize:     [34, 40],
		iconAnchor:   [17, 40], // point of the icon which will correspond to marker's location
		popupAnchor:  [0, -40], // point from which the popup should open relative to the iconAnchor
		//shadowAnchor: [14, 41]
	});
	var iconMarkerClick = L.icon({
		iconUrl: '/images/icon_marker_selected.svg',
		//shadowUrl: '/lib/leaflet/images/marker-shadow.png',
		iconSize:     [34, 40],
		iconAnchor:   [17, 40], // point of the icon which will correspond to marker's location
		popupAnchor:  [0, -40], // point from which the popup should open relative to the iconAnchor
		//shadowAnchor: [11, 41]
	});
	var allMarkers = {};
	var marker = [];
	
	
	function getLocationsLeaflet() {
		// clear all previous markers
		layerGroup.clearLayers();
		allMarkers = {};
		
		// ajax request for markers, depended on region
		$.post("/util/ajaxresponse.php",{
			'func': 'getMapLocationsLeaflet'
		}, function (data) {
			data = JSON.parse(data);
			var bounds = [];
			for (var key in data) {
				var position = [parseFloat(data[key].latitude), parseFloat(data[key].longitude)]
				marker[key] = L.marker(position, {icon: iconMarker,lat: parseFloat(data[key].latitude),lon: parseFloat(data[key].longitude),idMarkerja:data[key].id,imeMarkerja:data[key].title,textMarkerja:data[key].description, linkMarkerja:data[key].link}); // marker gets custom fields for id and location name
				
				marker[key].bindPopup(data[key].title);
				marker[key].addTo(layerGroup);
				allMarkers[marker[key].options.idMarkerja]=marker[key];
				bounds.push(position);

				marker[key].on('mouseover', function (e) {
					clearMarkerSelected();
					this.openPopup();
					this.setIcon(iconMarkerClick);
				});
				marker[key].on('click', function (e) {
					clearMarkerSelected();
					this.openPopup();
					this.setIcon(iconMarkerClick);
					let lat = map.getCenter().lat;
					let lng = this.options.lon;
					let coord = {lat:lat , lng:lng}
					let pixelPosition = map.latLngToLayerPoint(coord);
					
					if($(window).width()<991) { // mobile
						let overlayHeight = map.getSize().y * 0.6 ;
						var latLng = map.layerPointToLatLng({x:pixelPosition.x, y:pixelPosition.y});
					}
					else { // desktop
						let overlayWidth = map.getSize().x * 0.4;
						var latLng = map.layerPointToLatLng({x:(pixelPosition.x+(overlayWidth/2)), y:pixelPosition.y});
					}
					
					map.setView(latLng);
					$("#locationInfoTitle").html(this.options.imeMarkerja);
					$("#locationInfoText").html(this.options.textMarkerja);
					$("#moreAboutLocation").attr("href", this.options.linkMarkerja);
					$("#mapLocationsOverlay").show();
				});			
			}
			map.addLayer(layerGroup);
			if(bounds.length>0){ // if bounds is not empty, otherwise it throws error!
				map.fitBounds(bounds, {padding: [0, 50]}); // fits map zoom to show all markers
			}
			var tt = setTimeout(function(){
				marker[1].fire('click');
				$("#mapLocationsOverlay").show();
			}, 100);
		});
	}
	
	//functions for working with markers
	function clearMarkerSelected(){
		map.closePopup();
		for(const key in allMarkers)
			allMarkers[key].setIcon(iconMarker);
	}
});



/* --- Non-jQuery functions below --- */

//check if just one checkbox is checked
function isChecked(formId, message) {
	var form = document.getElementById(formId);

	for (i = 0; i < form.elements.length; i++) {
		if (form.elements[i].checked == true) {
			return true;
		}
	}
	alert(message);
	return false;
}

//mail decode
var mDec = function mDec(ensl, enlsShow, addToHref, insertHtml) {
	if (enlsShow == undefined || enlsShow == "") {
		enlsShow = ensl;
	}

	if (addToHref == undefined) {
		addToHref = "";
	}

	let a = "pdlowr=" + ensl;
	let nslv = "";
	for (let i = 0; i < a.length; i++) {
		let n = a.charCodeAt(i) - 3;
		nslv += String.fromCharCode(n);
	}

	let s = "";
	for (let i = 0; i < enlsShow.length; i++) {
		let n = enlsShow.charCodeAt(i);
		if (n >= 35 && n <= 126) {
			s += String.fromCharCode(n - 3);
		} else {
			s += enlsShow.charAt(i);
		}
	}

	if (insertHtml == '') {
		insertHtml = s;
	}

	document.write("<a class=\"email\" href=\"" + nslv + addToHref + "\">" + insertHtml + "</a>");
};


/*
 * function get elements by class name ... simiar to getElementsByTagName
 * leave container arg out, and will default to document.
 */
function getElementsByClassName(className, container) {
	if (!container) {
		container = document;
	}
	if (container.all) {
		var all = container.all;
	} else {
		var all = container.getElementsByTagName('*');
	}
	var arr = [];
	for (var k = 0; k < all.length; k++) {
		if (all[k].className == className) {
			arr[arr.length] = all[k];
		}
	}
	return arr;
}

/*
 * Closes a tree of uls/lis (a menu for example) if scripts are enabled. Else leaves
 * the list open, so it is accessible to other users.
 * Note: this could be done in jQuery, but the list needs to close
 * as soon as it is loaded, so jQuery is not an option here.
 */
function closeList(listId, sublevelsClassName, closeAtLevel) {
	var list = document.getElementById(listId);

	for (var i = closeAtLevel; i < 5; ++i) {
		var aUls = getElementsByClassName(sublevelsClassName + i, list);
		for (var j = 0; j < aUls.length; ++j) {
			if (aUls[j].tagName == 'UL') { // only close ULs
				aUls[j].style.display = "none";
			}
		}
	}
}

/*
 * Closes any element by ID
 */
function hideElementById(elId) {
	var el = document.getElementById(elId);
	el.style.display = "none";
}


if (document.getElementsByTagName) {
	var inputElements = document.getElementsByTagName("input");
	for (var i = 0; inputElements[i]; i++) {
		if (inputElements[i].className && (inputElements[i].className.indexOf("disableAutoComplete") != -1)) {
			inputElements[i].setAttribute("autocomplete", "off");
		}
	}
}
window.captchaCallback = captchaCallback;
window.urlDirFull = urlDirFull;
window.pageLng = pageLng;
window.initilizeLanguageSettings = initilizeLanguageSettings;
window.initializeAutoComplete = initializeAutoComplete;
window.setEqHeight = setEqHeight;
window.viewport = viewport;
window.openSlideContainers = openSlideContainers;
window.bindSlideAnchor = bindSlideAnchor;
window.scrollToOnLoadDirective = scrollToOnLoadDirective;
window.isChecked = isChecked;
window.mDec = mDec;
window.getElementsByClassName = getElementsByClassName;
window.closeList = closeList;
window.hideElementById = hideElementById;
window.inputElements = inputElements;
window.i = i;
}.call(window, window);